import { CheckCircleOutlineOutlined, InfoOutlined } from '@mui/icons-material';
import { Chip } from '@mui/material';

export function VerifiedCounter({ verifiedCount, totalCount }: any) {
  const verifiedLabel = `${verifiedCount} / ${totalCount} verified`;
  const allVerified = totalCount ? verifiedCount === totalCount : false;
  const fullyVerifiedColor = '#1AAE4E';
  const partiallyVerifiedColor = '#FFA34A';
  const verifiedColor = allVerified
    ? fullyVerifiedColor
    : partiallyVerifiedColor;
  const verifiedIcon = allVerified ? (
    <CheckCircleOutlineOutlined
      sx={{ color: `${fullyVerifiedColor} !important` }}
    />
  ) : (
    <InfoOutlined sx={{ color: `${partiallyVerifiedColor} !important` }} />
  );

  return (
    <Chip
      color="default"
      icon={verifiedIcon}
      label={verifiedLabel}
      sx={{ color: verifiedColor, backgroundColor: '#F5F6FA' }}
    />
  );
}
